import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './WhatWeDo.css';

const initiatives = [
  {
    id: 'academy',
    label: 'Education & Skills',
    title: 'YOCILAB Academy',
    desc: 'Expanding access to skills and knowledge young Africans need to shape the future — through AI, entrepreneurship, career readiness and the ABETA Builders Platform.',
    path: '/programs/yocilab-academy',
    img: require('../assets/YOCILAB Webiste photos/YOCILAB Home page/YOCILAB Academy.jpg'),
    color: 'var(--color-academy)',
    cta: 'Explore Academy',
  },
  {
    id: 'summit',
    label: 'Flagship Event',
    title: 'YOCILAB Youth Summit',
    desc: 'Africa\'s emerging platform for employability, innovation and youth leadership — connecting 500+ young people with employers, entrepreneurs, and opportunities.',
    path: '/youth-summit/register',
    img: require('../assets/YOCILAB Webiste photos/YOCILAB YOuth Summit/REMS0044.jpg'),
    color: 'var(--color-summit)',
    cta: 'Register Now',
    highlight: true,
  },
  {
    id: 'creative',
    label: 'Innovation Space',
    title: 'YOCILAB Creative Space',
    desc: 'A dynamic hub where young creators, tech innovators, and entrepreneurs collaborate, build, and launch ideas that solve real community challenges.',
    path: '/programs/yocilab-hub',
    img: require('../assets/YOCILAB Webiste photos/YOCILAB Creative Space/Creative space.jpg'),
    color: 'var(--color-primary)',
    cta: 'Visit the Space',
  },
  {
    id: 'ventures',
    label: 'Entrepreneurship',
    title: 'YOCILAB Ventures',
    desc: 'Supporting Africa\'s next generation of entrepreneurs with mentorship, funding pathways, and the tools to build ventures that create jobs and economic value.',
    path: '/ventures',
    img: require('../assets/YOCILAB Webiste photos/YOCILAB Ventures/DSC_9522.jpg'),
    color: '#2A7A4B',
    cta: 'Explore Ventures',
  },
];

const WhatWeDo = () => {
  const sectionRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    cardRefs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="initiatives" id="what-we-do" ref={sectionRef}>
      <div className="container">
        <div className="initiatives__header">
          <span className="section-label">OUR INITIATIVES</span>
          <h2 className="initiatives__title">
            Building the ecosystem<br />young Africa needs
          </h2>
          <p className="initiatives__desc">
            Four interconnected pillars that equip young people with skills, connect them to opportunity, and fuel inclusive economic growth.
          </p>
        </div>

        <div className="initiatives__grid">
          {initiatives.map((item, i) => (
            <div
              key={item.id}
              ref={(el) => (cardRefs.current[i] = el)}
              className={`initiative-card fade-up ${item.highlight ? 'initiative-card--highlight' : ''}`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="initiative-card__img-wrapper">
                <img
                  src={item.img}
                  alt={item.title}
                  className="initiative-card__img"
                  loading="lazy"
                />
                <div className="initiative-card__overlay" style={{ background: `linear-gradient(to top, ${item.color}EE 0%, transparent 60%)` }} />
                {item.highlight && (
                  <div className="initiative-card__badge">
                    <span className="initiative-card__badge-dot" />
                    Oct 31, 2026
                  </div>
                )}
              </div>

              <div className="initiative-card__content">
                <span className="initiative-card__label">{item.label}</span>
                <h3 className="initiative-card__title">{item.title}</h3>
                <p className="initiative-card__desc">{item.desc}</p>
                <Link to={item.path} className="initiative-card__cta">
                  {item.cta}
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M2 7H12M12 7L8 3M12 7L8 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
